import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Building2 } from 'lucide-react';
import { toast } from '../../hooks/use-toast';

/**
 * Modal listing multiple SIRENE search results, one card per company.
 * Extracted from CompanyFormDialog (Vague 97.4).
 */
export default function CompanySirenePicker({ open, onOpenChange, results, total, onPick }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[720px] max-h-[85vh] overflow-y-auto" data-testid="company-sirene-picker">
        <DialogHeader>
          <DialogTitle>Sélectionner une entreprise</DialogTitle>
          <DialogDescription>
            {results.length} résultat{results.length > 1 ? 's' : ''} affiché{results.length > 1 ? 's' : ''}
            {total > results.length ? ` sur ${total} au total — affinez votre recherche pour voir plus de candidats.` : '.'}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {results.map((r) => (
            <button
              key={r.siret || r.siren}
              type="button"
              onClick={() => {
                onPick(r);
                onOpenChange(false);
                toast({ title: 'Informations récupérées', description: r.name });
              }}
              data-testid={`picker-result-${r.siret || r.siren}`}
              className="w-full text-left p-3 rounded-xl border border-[#EFF0F6] bg-white hover:border-[#4F46E5] hover:bg-[#FAFAFE] transition-colors"
            >
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 rounded-xl bg-[#EEF2FF] flex items-center justify-center shrink-0">
                  <Building2 className="w-4 h-4 text-[#4F46E5]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-[13.5px] font-semibold text-[#1A1B2E] truncate">{r.name}</span>
                    {r.is_active ? (
                      <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded bg-[#E6FBF7] text-[#0F766E] text-[10px] font-semibold">Active</span>
                    ) : (
                      <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded bg-[#FEF2F2] text-[#B91C1C] text-[10px] font-semibold">Cessée</span>
                    )}
                  </div>
                  <div className="text-[11.5px] text-[#6B6C85] mt-0.5 font-mono">
                    SIRET {r.siret || '—'} · SIREN {r.siren || '—'}
                  </div>
                  <div className="text-[11.5px] text-[#6B6C85]">{r.address || '—'}</div>
                  <div className="text-[11px] text-[#8E8FA5] mt-0.5 flex gap-3 flex-wrap">
                    {r.legal_form && <span>{r.legal_form}</span>}
                    {r.naf_code && <span>NAF {r.naf_code}</span>}
                    {r.employees_count > 0 && <span>~{r.employees_count} salariés</span>}
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
        <DialogFooter>
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            className="h-10 px-4 rounded-xl bg-[#F6F7FB] text-[#4A4B63] text-[13px] font-semibold"
          >
            Fermer
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
